import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Grid, Typography, withWidth} from '@material-ui/core';
import {isWidthUp, isWidthDown} from "@material-ui/core/withWidth";
import {Fade} from 'react-reveal';

const imagePath = "/images/commerce.svg";
const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.white,
    padding: theme.spacing.unit * 10,
    paddingRight: 0,
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing.unit * 8,
      paddingRight: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing.unit * 4
    }
  },
  tagLine: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
    paddingBottom: theme.spacing.unit * 2
  },
  image: {
    maxWidth: '100%'
  },
  icon: {
    height: 48,
    width: 48,
  },
  description: {
    color: theme.palette.text.secondary,
    textAlign: 'center'
  },
  bottomDescription: {
    color: theme.palette.text.secondary
  },
  content: {
    // paddingLeft: theme.spacing.unit * 10,
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    }
  },
  contentItem: {
    padding: theme.spacing.unit * 4,
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: theme.spacing.unit * 4
    }
  }
});

const Commerce = withStyles(styles)(({classes, width}) => {

  const image = (
    <Grid item xs={12} md={6} lg={6}>
      <Fade right duration={1500} distance="50%">
        <object data={imagePath} className={classes.image}/>
      </Fade>
    </Grid>
  );
  return (
    <div className={classes.root}>
      <Grid container direction="column" justify="center" alignItems="center">
        <Grid item>
          <Typography variant="caption" color="secondary" gutterBottom className={classes.tagLine}>
            Commerce
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant={isWidthUp('md', width, false) ? 'h3' : 'h4'} gutterBottom align="center" color="inherit">
            Crypto Commerce
            <span style={{fontWeight: 'bold'}}> is here.</span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body2" className={classes.description}>
            Buy and Sell goods and services on CryptX Financial or Integrate our Payment Widget to your business site.
          </Typography>
          <Typography variant="body2" className={classes.description}>
            Access hundreds of businesses on CryptX Commerce with customized offers on products.
          </Typography>
        </Grid>
        <Grid item className={classes.content}>
          <Grid container direction={isWidthUp('md', width) ? 'row' : 'row-reverse'} justify="center"
                alignItems="center">
            {isWidthDown('md', width, false) && image}
            <Grid item xs={12} sm={12} md={6}>
              <Fade left duration={1500} distance="50%">
                <Grid container direction="column" justify="space-between" alignItems="center">
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/commerce/gateway.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10} sm={10} md={8}>
                      <Typography color="inherit" variant="h6">Gateway</Typography>
                      <Typography color="inherit" variant="body2" className={classes.bottomDescription}>
                        Vendors can collect payment for goods and services through an easy crypto payment gateway. This
                        can
                        be incorporated onto your site at no extra fee.
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/commerce/liquidity.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10} sm={10} md={8}>
                      <Typography color="inherit" variant="h6">Liquidity</Typography>
                      <Typography color="inherit" variant="body2" className={classes.bottomDescription}>
                        Once the Crypto payment is collected, you can setup Commerce to automatically dilute your crypto
                        into Fiat.
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/commerce/listing.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10} sm={10} md={8}>
                      <Typography color="inherit" variant="h6">Listing</Typography>
                      <Typography color="inherit" variant="body2" className={classes.bottomDescription}>
                        Goods and Services can be directly bought or sold on CryptX Financial with no extra seller fees.
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" className={classes.contentItem}>
                    <Grid item xs={2}>
                      <img src="/images/icons/commerce/subscriptions.svg" alt="Icon" className={classes.icon}/>
                    </Grid>
                    <Grid item xs={10} sm={10} md={8}>
                      <Typography color="inherit" variant="h6">Subscriptions</Typography>
                      <Typography color="inherit" variant="body2" className={classes.bottomDescription}>
                        Vendors can setup CryptX Financial for their customers to automatically recharge subscriptions
                        using
                        crypto on a time based or consumption based model.
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Fade>
            </Grid>
            {isWidthUp('md', width) && image}
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
});

export default withWidth()(Commerce);
